module.exports = __webpack_public_path__ + "img/instagram.0a162f32.svg";